﻿import LandingPage from "./Registration/LandingPage.svelte";
import PersonalDetails from "./Registration/PersonalDetails.svelte";
import PolicyDetails from "./Registration/PolicyDetails.svelte";
import DocumentUpload from "./Registration/DocumentUpload.svelte";
import Agreements from "./Registration/Agreements.svelte";
import Confirmation from "./Registration/Confirmation.svelte";
import Review from "./Registration/Review.svelte";
import ThankYou from "./Registration/ThankYou.svelte";
import SaveAndCloseThankYou from "./Registration/SaveAndCloseThankYou.svelte";
import Verify from "./Registration/Verify.svelte";
import RegistrationComplete from "./Registration/RegistrationComplete.svelte";

import FileUploadLandingPage from "./FileUpload/LandingPage.svelte";
import FileUploadFilesPage from "./FileUpload/Files.svelte";
import FileUploadThankYouPage from "./FileUpload/ThankYou.svelte";

import AgreementsAgreementPage from "./Agreements/Agreement.svelte";
import AgreementsLandingPage from "./Agreements/LandingPage.svelte";
import AgreementsThankYouPage from "./Agreements/ThankYou.svelte";

import Error from "./Error.svelte";

import { projectSettings } from "../config";

export const registrationPageList = [
	{
		pageIndex: 0,
		component: RegistrationComplete,
		title: "REGISTRATION SUBMITTED",
		showInTracker: false,
		routeId: "/RegistrationComplete",
		properties: {
			pageTitle: `${projectSettings.classActionName}`
		}
	},
	{
		pageIndex: 1,
		component: LandingPage,
		title: "Claimant Registration Form",
		showInTracker: true,
		routeId: "/Registration",
		nextPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${projectSettings.classActionName}`,
			lastVisitedPage: "Landing Page"
		}
	},
	{
		pageIndex: 2,
		component: PersonalDetails,
		title: "Personal Details",
		showInTracker: true,
		routeId: "/Registration/PersonalDetails",
		nextPage: (model) => (model.confirmationPage ? "/Registration/Confirmation" : "/Registration/PolicyDetails"),
		previousPage: "/Registration",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Personal Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Personal Details"
		}
	},
	{
		pageIndex: 3,
		component: PolicyDetails,
		title: "Policy Details",
		showInTracker: true,
		routeId: "/Registration/PolicyDetails",
		nextPage: (model) => (model.confirmationPage ? "/Registration/Confirmation" : "/Registration/DocumentUpload"),
		previousPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Policy Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Policy Details"
		}
	},
	{
		pageIndex: 4,
		component: DocumentUpload,
		title: "Document Upload",
		showInTracker: true,
		routeId: "/Registration/DocumentUpload",
		previousPage: "/Registration/PolicyDetails",
		nextPage: "/Registration/Confirmation",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Document Upload`,
			persistUrl: "/api/project",
			lastVisitedPage: "Document Upload"
		}
	},
	{
		pageIndex: 6,
		component: Confirmation,
		title: "Confirmation",
		showInTracker: true,
		routeId: "/Registration/Confirmation",
		previousPage: "/Registration/DocumentUpload",
		nextPage: "/Registration/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Confirmation`,
			nextPageLabel: "Submit",
			persistUrl: `/api/registration?timezoneOffset=${-1 * new Date().getTimezoneOffset()}`,
			lastVisitedPage: "Confirmation"
		}
	},
	{
		pageIndex: 7,
		component: ThankYou,
		title: "Registration Submitted",
		showInTracker: false,
		routeId: "/Registration/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Thank you`
		}
	},
	{
		pageIndex: 8,
		component: SaveAndCloseThankYou,
		title: "Registration Saved",
		showInTracker: false,
		routeId: "/Registration/SaveAndClose",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Thank you`
		}
	},
	{
		pageIndex: 9,
		component: Review,
		title: "Review",
		showInTracker: false,
		routeId: "/Review",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Review`
		}
	},
	{
		pageIndex: 10,
		component: Verify,
		title: "Claimant Registration Form",
		showInTracker: false,
		routeId: "/Verify",
		nextPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Verify`
		}
	},
	{
		pageIndex: 11,
		component: Error,
		title: "Error",
		showInTracker: false,
		routeId: "*/Error",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Error`
		}
	}
];

export const fileUploadPageList = [
	{
		pageIndex: 0,
		component: FileUploadLandingPage,
		title: "Landing Page",
		showInTracker: false,
		routeId: "/FileUpload",
		nextPage: "/FileUpload/Files",
		properties: {
			pageTitle: `${projectSettings.classActionName}`
		}
	},
	{
		pageIndex: 1,
		component: FileUploadFilesPage,
		title: "File upload form",
		showInTracker: true,
		routeId: "/FileUpload/Files",
		nextPage: "/FileUpload/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - File Upload`,
			persistUrl: "/api/file-upload-submit",
			lastVisitedPage: "File Upload Landing Page"
		}
	},
	{
		pageIndex: 2,
		component: FileUploadThankYouPage,
		title: "",
		showInTracker: false,
		routeId: "/FileUpload/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Thank You`
		}
	},
	{
		pageIndex: 3,
		component: Error,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} - Error`
	}
];

export const agreementPageList = [
	{
		pageIndex: 0,
		component: AgreementsLandingPage,
		title: "Landing Page",
		showInTracker: false,
		routeId: "/Agreements",
		nextPage: "/Agreements/ConfirmAgreements",
		properties: {
			pageTitle: `${projectSettings.classActionName}`
		}
	},
	{
		pageIndex: 1,
		component: AgreementsAgreementPage,
		title: "File upload form",
		showInTracker: true,
		routeId: "/Agreements/ConfirmAgreements",
		nextPage: "/Agreements/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Confirm Agreements`,
			persistUrl: `/api/confirm-agreements?timezoneOffset=${-1 * new Date().getTimezoneOffset()}`
		}
	},
	{
		pageIndex: 2,
		component: AgreementsThankYouPage,
		title: "",
		showInTracker: false,
		routeId: "/Agreements/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Thank You`
		}
	},
	{
		pageIndex: 3,
		component: Error,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} - Error`
	}
];
